import { useTranslation } from 'react-i18next';

import { Button, Modal, Alert } from '@hotjar/hotsauce';
import type { OrganizationModel } from '@hotjar/webapp/domains/sso/model';

interface Props {
  organization: OrganizationModel;
  onConfirmSubmit: () => void;
}

export const DisconnectionSuccessfulModal = ({
  organization,
  onConfirmSubmit,
}: Props): JSX.Element | null => {
  const { t } = useTranslation();
  const { name } = organization;
  const title = t('common:settings.sso.disconnect-modal.content.confirm-title', {
    name,
  });

  return (
    <>
      <Modal.Header title={title} />

      <Modal.Body>
        <Alert kind="success">
          {t('common:settings.sso.disconnect-modal.content.confirm-subtitle')}
        </Alert>
      </Modal.Body>

      <Modal.Footer>
        <Button kind="primary" onClick={onConfirmSubmit}>
          {t('common:settings.sso.disconnect-modal.content.done')}
        </Button>
      </Modal.Footer>
    </>
  );
};
